var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRteLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "8px",
    viewBox: "0 0 18 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rich-text-updates",
    transform: "translate(-769.000000, -117.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-link",
    transform: "translate(769.000000, 117.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.90909091,
    y: 3.2,
    width: 8.18181818,
    height: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9090909,0 C13.3265455,0 11.2189091,0 10.6363636,0 L10.6363636,1.6 C11.268,1.6 13.2774545,1.6 13.9090909,1.6 C15.2648182,1.6 16.3636364,2.6744 16.3636364,4 C16.3636364,5.3256 15.2648182,6.4 13.9090909,6.4 C13.2774545,6.4 11.268,6.4 10.6363636,6.4 L10.6363636,8 C11.2189091,8 13.3265455,8 13.9090909,8 C16.1680909,8 18,6.2088 18,4 C18,1.7912 16.1680909,0 13.9090909,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09090909,8 C4.67345455,8 6.78109091,8 7.36363636,8 L7.36363636,6.4 C6.732,6.4 4.72254545,6.4 4.09090909,6.4 C2.73518182,6.4 1.63636364,5.3256 1.63636364,4 C1.63636364,2.6744 2.73518182,1.6 4.09090909,1.6 C4.72254545,1.6 6.732,1.6 7.36363636,1.6 L7.36363636,0 C6.78109091,0 4.67345455,0 4.09090909,0 C1.83190909,0 0,1.7912 0,4 C0,6.2088 1.83190909,8 4.09090909,8 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRteLink);
export default __webpack_public_path__ + "static/media/icon-rte-link.18c464e12c1465eb0b092aad58e66005.svg";
export { ForwardRef as ReactComponent };